import { useEffect, useState } from 'react';

import { useNotification } from '../Contexts/NotificationContext';
import ContactItem from './ContactItem';

const ContactList = () => {
    const { setNotification } = useNotification();
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchContacts = async () => {
            try {
                const response = await fetch(`${baseUrl}/painel/contatos`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                const data = await response.json();
                setContacts(data.contatos);
            } catch (error) {
                setNotification({
                    type: 'error',
                    message: 'Erro ao buscar contatos:',
                    show: true,
                });
            } finally {
                setLoading(false);
            }
        };

        fetchContacts();
    }, []);

    if (loading)
        return (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 xl:gap-10 opacity-20">
                {[...Array(4)].map((_, index) => (
                    <div
                        key={index}
                        role="status"
                        className="flex items-center justify-center h-0 pb-[90%] md:pb-[103%] max-w-sm bg-gray-300 rounded-lg animate-pulse dark:bg-gray-700"
                    >
                        <span className="sr-only">Loading...</span>
                    </div>
                ))}
            </div>
        );

    return (
        <div className="bg-white rounded-lg shadow-lg p-6 overflow-auto">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-6 text-sm font-medium text-gray-500 min-w-[500px]">
                <div className="uppercase">Responsável/Contato</div>
                <div className="uppercase">Assunto</div>
            </div>

            {contacts.map((contact, index) => (
                <ContactItem key={index} contact={contact} />
            ))}
        </div>
    );
};

export default ContactList;
